let chatPoll = null
let messagePoll = null

export function startChatPolling(fn, interval = 8000) {
  stopAllPolling()
  chatPoll = setInterval(fn, interval)
}

export function startMessagePolling(fn, interval = 3000) {
  if (messagePoll) clearInterval(messagePoll)
  messagePoll = setInterval(fn, interval)
}

export function stopAllPolling() {
  if (chatPoll) {
    clearInterval(chatPoll)
    chatPoll = null
  }
  if (messagePoll) {
    clearInterval(messagePoll)
    messagePoll = null
  }
  console.log('🛑 GLOBAL polling stopped')
}
